import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomizeApiService {
  constructor(private api: HttpClient) {}

  setPrimaryColor(color: string, uiTheme: string): Observable<void> {
    const url = '/customize-design/set-primary-color/';
    const body = new HttpParams().set('primary_color', color).set('ui_theme', uiTheme);

    return this.api.post<null>(url, body.toString(), {
      withCredentials: true,
      responseType: 'json',
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
    });
  }

  getUploadUrl(): Observable<string> {
    const url = '/customize-design/generate-upload-url/';

    // This endpoint just writes the string to the response, so have to accept text here.
    return this.api.get(url, { responseType: 'text' });
  }

  deleteResource(partnerId: string, category: string): Observable<void> {
    const url = `/_res/delete/${partnerId}/${category}/`;

    return this.api.post<null>(url, null);
  }

  saveProductNames(businessCenterName = '', nationalBrandsName = ''): Observable<null> {
    const url = `/customize-design/product-names/`;
    const body = new HttpParams()
      .set('vbc_product_name_form-product_id', 'VBC')
      .set('vbc_product_name_form-product_name', businessCenterName)
      .set('nb_product_name_form-product_id', 'NB')
      .set('nb_product_name_form-product_name', nationalBrandsName)
      .set('business_directory_product_name_form-product_id', 'BD');

    return this.api.post<any>(url, body.toString(), {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
    });
  }

  saveExitLink(linkText: string, customUrl: string, logoutUrl: string, selectedLink: string): Observable<null> {
    const url = `/customize-design/exit-link/`;
    const body = new HttpParams()
      .set('exit_link_text', linkText)
      .set('exit_link_url', customUrl)
      .set('logout_link', logoutUrl)
      .set('customize_url_flag', selectedLink);

    return this.api.post<any>(url, body.toString(), {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
    });
  }
}
